const useStyles = () => ({
  tooltip: {
    fontSize: '14px',
  },
  formLabel: {
    '& .MuiFormLabel-root': {
      fontSize: '13px',
      marginTop: '-10px',
    },
  },
  menuPaper: {
    maxHeight: 200,
  },
});

export default useStyles;
